import React from "react"
import { Box } from "@mui/material"
import styles from "./ModalDefault.module.scss"
/**
 * デフォルトのモーダル
 */
const ModalDefault = () => {
  return (
    <>
      <Box className={styles.modalTitle}>
        <h3>
          対人賠償保険<span>保険金額は無制限</span>
        </h3>
      </Box>
      <Box className={styles.modalParagraph}>
        <p>
          ご契約のお車を運転中の事故などで他人を死傷させてしまった場合に、相手方に支払う治療費や慰謝料などが補填されます。専任担当者による示談交渉サービスつきです。
          <br />
          賠償金額が高額になるケースがあるため、「おとなの自動車保険 」では保険金額を無制限にしています。
        </p>
      </Box>
      <Box className={styles.modalTitle}>
        <h3>
          <img alt="caution" src="./icon-excramation-balloon.svg" />
          こんな場合に役立ちます
        </h3>
      </Box>
      <Box className={styles.modalList}>
        <ul>
          <li>歩行者と衝突し、死傷させてしまった</li>
          <li>車同士の事故により相手の車に乗車中の人に重度の後遺症が残るケガをさせてしまった</li>
        </ul>
      </Box>
    </>
  )
}

export default ModalDefault
